import store from '@/store'

function checkNotPermission(el, binding) {
  // console.log('checkNotPermission',binding)
  const { value } = binding
  const roles = store.getters && store.getters.roles
  if (!!!roles){
    return false
  }
  if (value && value instanceof Array) {
    if (value.length > 0) {
      const permissionRoles = value

      const hasPermission = roles.some(role => {
        return permissionRoles.includes(role)
      })

      if (hasPermission) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    }
  } else {
    throw new Error(`need roles! Like v-notpermission="['admin','editor']"`)
  }
}

export default {
  inserted(el, binding) {
    checkNotPermission(el, binding)
  },
  update(el, binding) {
    checkNotPermission(el, binding)
  }
}